module.exports = (__parcel__import__("gg246")).then(() => parcelRequire('4MKVl'));